import React, { Component } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { Modal, Button, Form } from 'react-bootstrap'; // Added react-bootstrap import
import DriversPowerSelect from './drivers-power-select.jsx';
import 'react-power-select/dist/react-power-select.css';
import moment from 'moment';

class DriversEventCalendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      url:props.url || null,
      showModal: false,
      driverList: [],
      startDate: null,
      endDate: null,
      driverNote: '',
      responseMessage : null,
      isUpdate : false,
      note_id : 0,
      isInputError : false,
    };
    this.calendarRef = React.createRef();
    this.handleSelectEventOfCalendar = this.handleSelectEventOfCalendar.bind(this);
    this.handleEventClick = this.handleEventClick.bind(this);
    this.handleSaveClick = this.handleSaveClick.bind(this);
    this.handleDeleteClick = this.handleDeleteClick.bind(this);
    this.handleClearClick = this.handleClearClick.bind(this);
    this.updateFullCalendarEvents = this.updateFullCalendarEvents.bind(this);
    this.getCalendarData = this.getCalendarData.bind(this);
    this.generateFullCalendarEvents = this.generateFullCalendarEvents.bind(this);
    this.setErrorState = this.setErrorState.bind(this);

    Echo.channel('driver-event-calendar-events').listen('DriverEventCalendarEvents', (e) => {
      this.getCalendarData();
    });
  }

  componentWillMount(){
    this.getCalendarData();
  }

  handleSelectEventOfCalendar(selected){
    this.setState({
      startDate: selected.start,
      endDate: selected.end,
      showModal: true,
      driverNote : '',
      isUpdate:false,
      note_id : 0,
      isInputError : false,
      responseMessage : false,
    });
  }

  handleEventClick(info) {
    const { event } = info;
    if (event) {
      this.setState({
        showModal: true,
        isUpdate:true,
        note_id : info.event.extendedProps.note_id,
        driverNote: info.event.title || '', 
        startDate: new Date(info.event.start),
        endDate: new Date(info.event.end),
        isInputError:false,
        responseMessage : false,
      });
    }
  }

  generateFullCalendarEvents() {
    const { driverList } = this.state;
    return driverList.map(({ note, start_time, end_time, id }) => ({
      title: `${note}`,
      start: start_time.split(' ')[0],
      end: end_time,
      allDay:true,
      note_id: id,
    }));
  }
  
  updateFullCalendarEvents() {
    const { driverList } = this.state;
    const calendarApi = this.calendarRef.current.getApi();
    const events = driverList.map(({ note, start_time, end_time, id }) => ({
      title: `${note}`,
      start: start_time.split(' ')[0],
      end: end_time,
      allDay:true,
      note_id: id,
    }));
    calendarApi.removeAllEvents();
    calendarApi.addEventSource(events);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.startDate !== this.state.startDate ||
      prevState.driverList !== this.state.driverList
    ) {
      this.updateFullCalendarEvents();
    }
  }

  handleClearClick() {
    this.setState({
      driverNote: '',
      isUpdate:false,
      note_id : 0,
      isInputError : false,
      responseMessage : false,
    });
  }

  getCalendarData(){
    $.ajax({
      type: "GET",
      url: this.state.url,
      dataType: "text/json",
      headers: {
        "Authorization": 'Bearer ' + window.api_token
        , "Accept": 'application/json'
      },
      complete: function(response) {
        if(response.status==200)
        {
          const responseData = JSON.parse(response.responseText);
          this.setState({
            driverList: responseData.data,
          });
          this.updateFullCalendarEvents();
        }
      }.bind(this)
    });
  }

  handleSaveClick() {
    const {driverNote, startDate,endDate, note_id, isUpdate } = this.state;
    const driverCallenderData = {
      driver_note: driverNote,
      note_id,
      start_date: moment(startDate).format('YYYY-MM-DD hh:mm:ss'),
      end_date: moment(endDate).format('YYYY-MM-DD hh:mm:ss'),
      api_token: window.api_token,
    };
    $.ajax({
      type: 'POST',
      url: '/api/v1/portal/drivers/event/save-driver-calendar',
      data: driverCallenderData,
      dataType: 'text/json',
      complete: (response) => {
        if (response.status === 200) {
          const responseData = JSON.parse(response.responseText);
          this.setState({ responseMessage: responseData.message });
            this.setState({
              showModal: false,
              responseMessage: null,
            });
        } else {
          this.setState({ showModal: false });
        }
      },
    });
  }
  
  setErrorState(message) {
    this.setState({
      responseMessage: message,
      isInputError: true,
    });
  }
  
  renderEventContent(eventInfo) {
    return (
      <>
        {/* <b style={{color:'black',backgroundColor:'white'}}> {eventInfo.event.extendedProps} </b> */}
        <i title={eventInfo.event.title}>
          {_.truncate(eventInfo.event.title, {'length': 24})}
        </i>
      </>
    )
  }

  handleDeleteClick(){
    const { note_id } = this.state;
    const driverCallenderData = {
      note_id,
      api_token: window.api_token,
    };
    $.ajax({
      type: 'DELETE',
      url: '/api/v1/portal/drivers/event/calendar-event/delete',
      data: driverCallenderData,
      dataType: 'text/json',
      complete: (response) => {
        if (response.status === 200) {
            this.setState({
              showModal: false,
            });
        } else {
          this.setState({ showModal: false });
        }
      },
    });
  }

  render() {
    const { driverNote } = this.state;
    return (
      <>
      <FullCalendar
        ref={this.calendarRef}
        plugins={[dayGridPlugin, interactionPlugin]}
        initialView="dayGridMonth"
        selectable={true}
        events={this.generateFullCalendarEvents()}
        // eventContent={(eventInfo) => this.renderEventContent(eventInfo)}
        select={(selected) =>this.handleSelectEventOfCalendar(selected)}
        eventClick={(info) => this.handleEventClick(info)}
        height={850}
        expandRows={true}
        weekends={true}
      />

      <Modal 
        show={this.state.showModal} 
        onHide={() => this.setState({ showModal: false })} 
        centered 
        backdrop="static" 
        className="driver-calendar-model"
        enforceFocus={false}
        >
        <Modal.Header closeButton>
              <Modal.Title>{this.state.driver_id ? 'Edit Event' : 'Add Event'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="driverNoteTextarea">
            <div className="row  text-center mb-2">
                <label className="col-md-3 text-left">Event Note: </label>
                <div className="col-md-9">
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={driverNote}
                    onChange={(e) => this.setState({ driverNote: e.target.value })}
                  />
                </div>
            </div>
            {this.state.responseMessage && (
              <div className="row text-center">
                <div className="col-md-3"></div>
                  <div className={`col-md-9 alert ${!this.state.isInputError ? 'alert-success' : 'alert-danger'} text-center`} role="alert" style={{ margin: '20px 0' }}>
                    {this.state.responseMessage}
                  </div>
              </div>
            )}
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          {this.state.isUpdate ? 
          <Button variant='outline-danger' onClick={this.handleDeleteClick}>
            Delete
          </Button>
          :''}
          <Button variant="primary" onClick={this.handleSaveClick}>
            {this.state.isUpdate ? 'Update' : 'Save'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
    );
  }
}

export default DriversEventCalendar;
